module.exports = __webpack_public_path__ + "static/img/banner_04.ad23dbc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/banner_04.jpg
// module id = FglU
// module chunks = 9